export enum Multimedia {
  Image = "image",
  Video = "video",
  Document = "file",
}

export enum MultimediaKeyOption {
  Media = "media", // para image y video
  Document = "file",
}

export enum MultimediaValue {
  Image = 11,
  Document = 12,
  Video = 13,
}

export interface MultimediaType {
  type: Multimedia.Image | Multimedia.Video | Multimedia.Document;
  formats: {
    values: string[];
    accept: string;
  };
  max_size: number;
  type_in_node: MultimediaValue;
}

export interface MultimediaOption {
  title: string;
  multimedia: Multimedia[];
  max_size_title: string;
}
